phina.namespace(function() {

  phina.define("ps.ZankiDisplay", {
    superClass: "ps.ItemDisplay",

    init: function(initialValue) {
      this.superInit("zanki", initialValue);
    },

  });
});
